import React from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import ModalContainer from 'react-modal-promise';
import * as Sentry from '@sentry/react';
import {
  createStyles,
  makeStyles,
} from '@material-ui/core';

import CookiesNotification from 'src/components/CookiesNotification';
import SettingsNotification from 'src/components/SettingsNotification';
import ScrollReset from 'src/components/ScrollReset';
import Routes from 'src/Routes';
import { AppProviders } from './providers';
import { UnexpectedErrorFallback } from './views/pages/UnexpectedErrorFallback';

const history = createBrowserHistory();

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
      },
      html: {
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        height: '100%',
        width: '100%',
      },
      body: {
        height: '100%',
        width: '100%',
      },
      '#root': {
        height: '100%',
        width: '100%',
      },
    },
  })
);


function App() {
  useStyles();
  return (
    <Router history={history}>
      <Sentry.ErrorBoundary fallback={UnexpectedErrorFallback} reset>
        <AppProviders>
          <ScrollReset />
          <CookiesNotification />
          <SettingsNotification />
          <ModalContainer />
          <Routes />
        </AppProviders>
      </Sentry.ErrorBoundary>
    </Router>
  );
}

export default Sentry.withProfiler(App);
